import "../Styles/index.scss";

let navOverlay = document.querySelector(".nav-overlay");
if (navOverlay != null) {
	for (let element of document.querySelectorAll(".nav-toggle")) {
		element.addEventListener("click", e => {
			navOverlay?.classList.toggle("is-active");
		});
	}
}

import { setupGallery } from "./gallery";
setupGallery();

import { mount, unmount } from "svelte";
import Modal from "./modal.svelte";
import ContactForm from "./contact-form.svelte";
for (let element of document.querySelectorAll<HTMLElement>("a[href^='bluc-action:']")) {
	let [action, param] = element.getAttribute("href")!.substring("bluc-action:".length).split("/");
	element.addEventListener("click", async e => {
		e.preventDefault();

		if (action === "open-modal") {
			let component = null;
			switch (param) {
				case "contactform":
					component = ContactForm;
					break;
				default:
					console.warn(`Unknown modal component: ${param}`);
					return;
			}

			let modal = mount(Modal, {
				target: document.body,
				props: {
					component: component,
					source: {
						buttonText: element.innerText,
						path: window.location.pathname,
						pageTitle: document.title,
					},
					closed: () => unmount(modal, { outro: true })
				}
			});
		}
	});
}

import { initializeMaps } from "@wagich/bluc-map";
initializeMaps();

import { Fancybox, Panzoom, PanzoomAction, PanzoomZoomLevel } from "@fancyapps/ui";

Fancybox.bind(".is-zoomable", {
	groupAttr: "data-gallery",
});

let teamGroupImageContainer = document.querySelector<HTMLElement>(".team-groupimage");
if (teamGroupImageContainer != null) {
	const panzoom = Panzoom(teamGroupImageContainer, {
		clickAction: PanzoomAction.IterateZoom,
		maxScale: 2,
		minScale: PanzoomZoomLevel.Cover,
		startPos: { scale: PanzoomZoomLevel.Cover },
	}).init();

	const dragHint = document.querySelector<HTMLElement>(".team-groupimage__drag-hint");

	// Load high-res image when zooming in past cover level
	let highResLoaded = false;
	const loadHighRes = () => {
		if (highResLoaded) {
			return;
		}
		const currentScale = panzoom.getTransform().scale;
		const coverScale = panzoom.getScale("cover");
		if (currentScale > coverScale) {
			const img = teamGroupImageContainer!.querySelector<HTMLImageElement>(".f-panzoom__viewport img[data-src]");
			if (img) {
				highResLoaded = true;
				img.src = img.dataset.src!;
			}
		}
	};
	panzoom.on("animationEnd", loadHighRes);
	panzoom.on("wheel", loadHighRes);
}
